export default "__VITE_ASSET__4S7TV2V___"